import { useEffect } from "react";
import style from "./pickers.module.css";
import classNames from "classnames";
import { RequiredFieldMark } from "./required-field-mark";
import { MondayColumn } from "shared/integrations/mapper";
import tracking from "frontend/tracking";
import consts from "shared/consts";

export function GeneralColumnEditor({ column }: { column: MondayColumn }) {
  useEffect(() => {
    column.required &&
      tracking.trackAnalyticsEvent("create monday item with required column", {
        columnType: column.type,
        category: consts.TRACKING_CATEGORY.INTEGRATIONS,
      });
  }, []);

  function renderMainLabel() {
    return (
      <div title={column.title} className={style.cropText}>
        Choose value
        {column.required && <RequiredFieldMark />}
      </div>
    );
  }

  const theme = "dark";

  return (
    <div>
      <div className={classNames(style.selectTrigger, style[theme])}>{renderMainLabel()}</div>
    </div>
  );
}
